import React from "react";
import { useTheme } from "@mui/material/styles";
import {
  useMediaQuery,
  Grid,
  List,
  ListItem,
  Stack,
  Typography,
} from "@mui/material";

// project import
import MainCard from "../../../../../../components/MainCard";
import { OrderItem } from "../../../../../../types/orders-managment/orders";

const ExpandingOrderItemDetail = ({ data }: { data: OrderItem }) => {
  const theme = useTheme();
  const matchDownMD = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Grid
      container
      spacing={3.5}
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <Grid item xs={12} sm={7} md={12} xl={8.5}>
        <Stack spacing={2.5}>
          <MainCard title="Order Item Details">
            <List sx={{ py: 0 }}>
              <ListItem divider={!matchDownMD}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">ID</Typography>
                      <Typography>{data.id}</Typography>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">Order ID</Typography>
                      <Typography>{data.order_id}</Typography>
                    </Stack>
                  </Grid>
                </Grid>
              </ListItem>

              <ListItem divider={!matchDownMD}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">Packable Type</Typography>
                      <Typography>{data.packable_type}</Typography>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">Price</Typography>
                      <Typography>{data.price.toLocaleString()}</Typography>
                    </Stack>
                  </Grid>
                </Grid>
              </ListItem>

              <ListItem divider={!matchDownMD}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">
                        Package Validity
                      </Typography>
                      <Typography>{data.package_validity} days</Typography>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">
                        Package Duration
                      </Typography>
                      <Typography>{data.package_duration} days</Typography>
                    </Stack>
                  </Grid>
                </Grid>
              </ListItem>

              <ListItem divider={!matchDownMD}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">Start Date</Typography>
                      <Typography>{data.start_date}</Typography>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">End Date</Typography>
                      <Typography>{data.end_date}</Typography>
                    </Stack>
                  </Grid>
                </Grid>
              </ListItem>

              {/* Meta fields */}
              <ListItem divider={!matchDownMD}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">Show Logo</Typography>
                      <Typography>
                        {data.meta.show_logo ? "Yes" : "No"}
                      </Typography>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">Show in App</Typography>
                      <Typography>
                        {data.meta.show_in_app ? "Yes" : "No"}
                      </Typography>
                    </Stack>
                  </Grid>
                </Grid>
              </ListItem>

              <ListItem divider={!matchDownMD}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">
                        Show in Best Place
                      </Typography>
                      <Typography>
                        {data.meta.show_in_best_place ? "Yes" : "No"}
                      </Typography>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">Vacancy Count</Typography>
                      <Typography>{data.meta.vacancy_count}</Typography>
                    </Stack>
                  </Grid>
                </Grid>
              </ListItem>

              {/* Packable details */}
              <ListItem divider={!matchDownMD}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">Packable Note</Typography>
                      <Typography>{data.packable.note}</Typography>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">
                        Packable Price/Unit
                      </Typography>
                      <Typography>
                        {data.packable.price_per_unit.toLocaleString()}
                      </Typography>
                    </Stack>
                  </Grid>
                </Grid>
              </ListItem>

              <ListItem>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">Packable Fees</Typography>
                      <Typography>
                        {data.packable.fees.toLocaleString()}
                      </Typography>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">Created At</Typography>
                      <Typography>{data.packable.created_at}</Typography>
                    </Stack>
                  </Grid>
                </Grid>
              </ListItem>
            </List>
          </MainCard>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default ExpandingOrderItemDetail;
